import Immerable from "../../../store/immerable";
import { v4 as uuidv4 } from 'uuid';

export enum NotificationType {
    Information, Success, Failure, Warning, Error
}

export class SessionNotification extends Immerable {
    id: string;
    message: string;
    type: NotificationType;
    detailedMessage?: string;

    constructor(id: string | undefined, message: string, type: NotificationType, detailedMessage?: string) {
        super();

        // if id was undefined, generate it
        this.id = id || `mv-notif-${uuidv4()}`;

        this.message = message;
        this.type = type;
        this.detailedMessage = detailedMessage;
    }
}

export function notificationTypeToBootstrapVariant(type: NotificationType) {
    switch (type) {
        case NotificationType.Success:
            return 'success';
        case NotificationType.Failure:
            return 'danger';
        case NotificationType.Warning:
            return 'warning';
        case NotificationType.Error:
            return 'danger';
        case NotificationType.Information:
        default:
            return 'secondary';
    }
}
